var Alchemy = {
  handle: 'alchemy',

  abilities: {
    poison_weapon: {
      handle: 'poison_weapon',
      unlockLevel: 1,
    },

    burning_hands: {
      handle: 'burning_hands',
      unlockLevel: 4,
    },

    molotov_cocktail: {
      handle: 'molotov_cocktail',
      unlockLevel: 12,
    },

    ice_nine: {
      handle: 'ice_nine',
      unlockLevel: 20,
    },

    fumigate: {
      handle: 'fumigate',
      unlockLevel: 28,
    },

    lightning: {
      handle: 'lightning',
      unlockLevel: 36,
    },

    road_to_nowhere: {
      handle: 'road_to_nowhere',
      unlockLevel: 44,
    },
  },
};
module.exports = Alchemy;
